<template>
	<div>
		<div class="flex flex-col lg:flex-row gap-x-2 gap-y-3">
			<div class="w-full lg:w-1/3 max-h-[23rem]">
				<benchmark-chart
					title="Portfolio Benchmark to Market"
					:benchmark="portfolioBenchmark"
					height="235"
				></benchmark-chart>
				
			</div>

			<div class="w-full lg:w-1/3 max-w-3xl max-h-[23rem]">
				<upcoming-portfolio 
					ref="leasesDueInComponent"
					:site-data="sites" 
					full-height
					@leases-due-tooltip="handleLeasesDueTooltip"
					>
				</upcoming-portfolio>
			</div>

			<div class="w-full lg:w-1/3 max-w-3xl">
			    <div class="h-full bg-box rounded shadow-md">
			        <div class="flex flex-col justify-between h-full">
						<div class="site-title-bar relative flex items-center justify-center px-4 py-2 bg-gray-800 rounded-t">
							<div class="text-white text-xl font-bold">Active Projects</div>
							<div class="absolute right-4">
								<InfoIcon 
									identifier="dashboard-activeprojects"
                  					@visibility-change="handleActiveProjectsTooltip" 
								/>
							</div>
						</div>
			            <div class="relative flex-1 flex justify-center items-center">
							<pie-chart
							   	v-show="!leasesDueTooltipVisible"
								:data="activeProjectsChartData"
								height="300"
								:legend-font-size="15"
								:legend-number-columns="2"
								:enable-smart-labels="false"
								:show-percent-values="false">
							</pie-chart>
			            </div>
			        </div>
			    </div>
			</div>
		</div>

		<div class="mt-5 mb-20 flex">
			<dashboard-portfolio-table
				:project-data="projects"
				:site-data="sites"
			></dashboard-portfolio-table>
		</div>
	</div>
</template>

<script>

	export default {
	    name: 'ReoptDashboard',

		props: ['projects', 'activeProjectsChartData', 'sites', 'portfolioBenchmark'],
		data() {
			return {
			  	leasesDueTooltipVisible: false,
      			activeProjectsTooltipVisible: false
			}
		},
		methods: {
			handleLeasesDueTooltip(visible) {
				this.leasesDueTooltipVisible = visible;
			},
			handleActiveProjectsTooltip(visible) {
				this.activeProjectsTooltipVisible = visible;
			}
		}
	}
</script>
